import debounce from "./debounce";

function triggerLeavingPopUp() {
  const isPresent = document.querySelector(".c-gen-window-wrapper");
  if (!isPresent) {
    return;
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  }

  function onMouseOut(event) {
    // If the mouse is near the top of the window, show the popup
    // Also, do NOT trigger when hovering or clicking on selects
    if (
      event.clientY < 50 &&
      event.relatedTarget == null &&
      event.target.nodeName.toLowerCase() !== "select"
    ) {
      // Remove this event listener
      document.removeEventListener("mouseout", onMouseOut);

      // Show the popup
      const popup = document.querySelector(".c-gen-window-wrapper");
      const close = document.querySelectorAll(".c-gen-window-close");

      if (!popup.classList.contains("closed")) {
        popup.classList.remove("hidden");
      }

      document.onkeyup = function (event) {
        if (event.keyCode === 27) {
          popup.classList.add("hidden");
          popup.classList.add("closed");
          setCookie("leaving_window_shown", "yes", 365);
        }
      };

      close.forEach((item) => {
        item.addEventListener("click", function () {
          popup.classList.add("hidden");
          popup.classList.add("closed");
          setCookie("leaving_window_shown", "yes", 365);
        });
      })

    }
  }

  if (getCookie("leaving_window_shown") === "yes") {
    // don't show the popup
  } else {
    document.addEventListener("mouseout", onMouseOut);
  }
}

export default triggerLeavingPopUp;
